import mudify4x4Defaults from '../mudify4x4/config.js';
import { AfterInit as packagesAfterInit } from '../mudify4x4/liftKitPackages.js';
import { createVehicleLandingSync } from '../mudify4x4/vehicleLandingSync.js';

const syncLandingVehicle = createVehicleLandingSync(['Make', 'Model', 'Generation']);

const normalizeCategoryUrl = (url) => {
  if (!url) {
    return '';
  }

  const withoutOrigin = url.replaceAll(window.location.origin, '').trim();
  const [pathOnly] = withoutOrigin.split(/[?#]/, 1);
  return (pathOnly || '').replace(/\/+$/, '');
};

function getVehicleCategoryUrls() {
  return [
    ...new Set(
      [...window.document.querySelectorAll('[data-category-option][data-category-url]')]
        .map((option) => normalizeCategoryUrl(option.dataset.categoryUrl))
        .filter(Boolean),
    ),
  ];
}

function getSelectedVehicleCategoryUrl() {
  const activeOption = window.document.querySelector(
    "[data-category-dropdown] [data-category-menu] [data-category-option][aria-pressed='true']",
  );
  if (activeOption?.dataset?.categoryUrl) {
    return normalizeCategoryUrl(activeOption.dataset.categoryUrl);
  }

  const shop = window.document.querySelector('home-vehicle-shop');
  if (shop?.dataset?.activeCategoryKey || shop?.dataset?.activeCategoryUrl) {
    const { activeCategoryKey, activeCategoryUrl } = shop.dataset;

    return normalizeCategoryUrl(activeCategoryUrl) || `/collections/${activeCategoryKey}`;
  }

  if (window.location.pathname.startsWith('/collections/')) {
    return normalizeCategoryUrl(window.location.pathname);
  }

  return '';
}

function homeCategoryYmmOnSubmit() {
  const categoryUrl = getSelectedVehicleCategoryUrl();
  if (!categoryUrl) {
    return;
  }

  const redirects = window.Convermax.modify4x4CategoryRedirects || {};
  window.location.assign(redirects[categoryUrl] || categoryUrl);
}

function responseHandler(response) {
  const mudify4x4DefaultsResponse = mudify4x4Defaults.responseHandler?.(response) ?? response;
  window.Convermax.modify4x4CategoryRedirects =
    mudify4x4DefaultsResponse?.Extra?.modify4x4CategoryRedirects || {};
  return mudify4x4DefaultsResponse;
}

function AfterInit() {
  packagesAfterInit?.();
  syncLandingVehicle();

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-category-option]')) {
      setTimeout(() => {
        document.querySelector('#cm-ymm-home .cm_vehicle-widget_button__clear')?.click();
      }, 100);
    }
  });
}

export default {
  includes: ['mudify4x4', 'shopify-spark-generic'],
  ...mudify4x4Defaults,
  AfterInit,
  responseHandler,
  storeId: 'mudify4x4-staging',
  Widgets: [
    ...mudify4x4Defaults.Widgets.filter((w) => w.name !== 'HomeVehicleWidget_tab'),
    {
      name: 'HomeVehicleWidget_tab',
      type: 'RequestPanel',
      location: { selector: '#cm-ymm-home', class: 'cm_vehicle-widget__home-with-category' },
      template: 'HomeVehicleWidgetPanel',
      isAutoRedirectDisabled: true,
      needInitRequest: true,
      redirectUrl: window.location.pathname,
      selectFields: ['Make', 'Model', 'Generation', 'BodyNumDoors'],
      requiredFields: ['Make', 'Model', 'Generation'],
      requestExtra: {
        get vehicleCategoryUrls() {
          return getVehicleCategoryUrls();
        },
        get selectedCategoryUrl() {
          return getSelectedVehicleCategoryUrl();
        },
      },
      onSubmit: () => {
        homeCategoryYmmOnSubmit();
        // кeplace intermediate search page history entry with home.
        const homePath = window.Convermax.Shopify?.getRootRoute?.() || '/';
        const searchPath = window.Convermax?.config?.searchPageUrl || '/pages/search';
        window.addEventListener(
          'pagehide',
          () => {
            if (window.location.pathname === searchPath) {
              window.history.replaceState(null, '', homePath);
            }
          },
          { once: true },
        );
      },
    },
  ],
};
